import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { useTheme } from "@/hooks/useTheme";
import { SignupForm } from "@/containers/SignupForm";
import useTranslation from "next-translate/useTranslation";

export const NewsletterSignupSection: React.FC = () => {
  const { css } = useFela();
  const { colors, bp } = useTheme();
  const { t } = useTranslation();

  return (
    <Grid
      id="NewsletterSignupSection"
      customStyle={{
        justifyContent: "center",
        margin: "0px auto 40px",
        [bp.FROM_TABLET]: {
          padding: 0,
        },
        [bp.FROM_DESKTOP]: {
          padding: 0,
        },
      }}
    >
      <div
        className={css({
          maxWidth: 620,
          padding: "50px 80px",
          backgroundColor: colors.WHITE,
          borderRadius: 8,
          boxShadow: `20px 20px 80px 0 ${colors.CETACEAN_BLUE}`,
        })}
      >
        <div
          className={css({
            textAlign: "center",
          })}
        >
          <Heading
            as="h2"
            customStyle={{
              [bp.FROM_DESKTOP]: { fontSize: 28, lineHeight: 1.21 },
            }}
          >
            {t("section/newsletterSignup:title")}
          </Heading>
        </div>
        <p
          className={css({
            textAlign: "center",
            marginBottom: 30,
            fontSize: 18,
            lineHeight: "28px",
          })}
        >
          {t("section/newsletterSignup:subtitle")}
        </p>

        <SignupForm />
      </div>
    </Grid>
  );
};
